<template>
  <div>
    <div class="">
      <nav-bar class="d-none d-sm-block " ref="form"/>
      <div class=" d-block d-sm-none">
        <router-link to="allProducts">
          <v-btn
              elevation="0"
              color="secondary"
              class="rounded-lg m-2"
              @click="overlay = !overlay"
          >
            <i class="fas fa-angle-left"></i>
            <span class="white--text pr-5 ">بازگشت</span>
          </v-btn>
        </router-link>
      </div>
      <div v-if="isPageLoaded" class=" py-10">
        <div class="container">
          <div class="row">
            <div class="col-12  mx-auto text-center d-inline-block d-md-none">
              <img class="img-fluid" :src="$replaceHttps(ProductDetails.imageUrl)" width="400" height="400"
                   alt="عکس محصول">
            </div>
            <div class="col-12 col-md-6 mx-auto  rounded-">
              <div class=" primaryColor  font">
                <div class=" font "> {{ ProductDetails.productName }}</div>
              </div>
              <div class=" pt-5 font" v-html="ProductDetails.description"></div>
            </div>
            <div class="col-12 col-sm-6 text-left d-none d-md-block ">
              <img class="img-fluid" :src="$replaceHttps(ProductDetails.imageUrl)" width="400" height="400"
                   alt="عکس محصول">
            </div>
          </div>
          <div class="tired-bg  text-center font-18 ">
            جزییات محصول
          </div>
          <div class="row ">
            <div class="col-12 col-md-6">
              <div class="sec-garay-bg ">
                <table class="col-12 ">
                  <tbody>
                  <tr class="border-top">
                    <td class="text-center ">mm</td>
                    <td class="text-left font font-weight-bold ">{{ ProductDetails.platenSize }}</td>
                    <td class="text-left border-right border-left">Platen Size</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center ">mm</td>
                    <td class="text-left font font-weight-bold">{{ ProductDetails.spaceBetweenTieBar }}</td>
                    <td class="text-left border-right border-left">Space Between Tie Bar</td>
                  </tr>
                  <tr class="border-top ">
                    <td class="text-center ">mm</td>
                    <td class="text-left font font-weight-bold">{{ ProductDetails.mouldThickness }}</td>
                    <td class="text-left border-right border-left">Mould Thickness min/max</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center ">KN</td>
                    <td class="text-left font font-weight-bold"> {{ ProductDetails.ejectorForce }}</td>
                    <td class="text-left border-right border-left"> Ejector Force</td>
                  </tr>
                  <tr class="border-top ">
                    <td class="text-center ">mm</td>
                    <td class="text-left font font-weight-bold">{{ ProductDetails.ejectorStroke }}</td>
                    <td class="text-left border-right border-left">Ejector Stroke</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center ">unit</td>
                    <td class="text-left font font-weight-bold">{{ ProductDetails.numberOfThimbles }}</td>
                    <td class="text-left border-right border-left">Number Of Thimbles</td>
                  </tr>
                  <tr class="border-top bg-primary">

                    <td class="text-left font font-weight-bold table-bg"></td>
                    <td class="text-left  border-none table-bg"></td>
                    <td class="text-left  font-weight-bold table-bg white--text">POWER/HEATING</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center ">KW</td>
                    <td class="text-left font font-weight-bold"> {{ ProductDetails.pumpMotor }}</td>
                    <td class="text-left border-right border-left">Pump Motor</td>
                  </tr>
                  <tr class="border-top ">
                    <td class="text-center ">MPa</td>
                    <td class="text-left font font-weight-bold">{{ ProductDetails.hydraulicSystemPressure }}</td>
                    <td class="text-left border-right border-left">Hydraulic System Pressure</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center ">unit</td>
                    <td class="text-left  font font-weight-bold">{{ ProductDetails.noOfTempControlZones }}</td>
                    <td class="text-left border-right border-left">No Of Temp Control Zones</td>
                  </tr>
                  <tr class="border-top ">
                    <td class="text-center border-bottom">KW</td>
                    <td class="text-left font font-weight-bold border-bottom">{{ ProductDetails.heatingCapacity }}</td>
                    <td class="text-left border-right border-left border-bottom">Heating Capacity</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-12 col-md-6 ">
              <div class=" ">
                <table class="col-12 ">
                  <tbody>
                  <tr class="border-top">
                    <td class="text-center "></td>
                    <td class="text-left font font-weight-bold border-none">{{ ProductDetails.interNationalSizeRating }}</td>
                    <td class="text-left border-right border-left">InterNational Size Rating</td>
                  </tr>
                  <tr class="border-top bg-primary">

                    <td class="text-left font font-weight-bold table-bg"></td>
                    <td class="text-left  border-none table-bg"></td>
                    <td class="text-left  font-weight-bold table-bg white--text">INJECTION UNIT</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center ">mm</td>
                    <td class="text-left font font-weight-bold">{{ ProductDetails.screwDiameter }}</td>
                    <td class="text-left border-right border-left">Screw Diameter</td>
                  </tr>
                  <tr class="border-top ">
                    <td class="text-center ">cc</td>
                    <td class="text-left font font-weight-bold"> {{ ProductDetails.theoreticalShotVolume }}</td>
                    <td class="text-left border-right border-left">Theoretical Shot Volume</td>
                  </tr>
                  <tr class="border-top ">
                    <td class="text-center ">g-OZ</td>
                    <td class="text-left font font-weight-bold"> {{ ProductDetails.theoreticalShotWeight }}</td>
                    <td class="text-left border-right border-left">Theoretical Shot Weight</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center ">L/D</td>
                    <td class="text-left font font-weight-bold">{{ ProductDetails.screwLDRatio }}</td>
                    <td class="text-left border-right border-left">Screw LD Ratio</td>
                  </tr>
                  <tr class="border-top ">
                    <td class="text-center ">MPa</td>
                    <td class="text-left font font-weight-bold"> {{ ProductDetails.injectionPressure }}</td>
                    <td class="text-left border-right border-left">Injection Pressure</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center ">rpm</td>
                    <td class="text-left font font-weight-bold">{{ ProductDetails.screwSpeed }}</td>
                    <td class="text-left border-right border-left">Screw Speed</td>
                  </tr>
                  <tr class="border-top bg-primary">

                    <td class="text-left font font-weight-bold table-bg"></td>
                    <td class="text-left  border-none table-bg"></td>
                    <td class="text-left  font-weight-bold table-bg white--text">CLAMPING UNIT</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center ">KN</td>
                    <td class="text-left font font-weight-bold">{{ ProductDetails.clampingForce }}</td>
                    <td class="text-left border-right border-left "> Clamping Force</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center ">mm</td>
                    <td class="text-left font font-weight-bold">{{ ProductDetails.maxDaylight }}</td>
                    <td class="text-left border-right border-left">Max Daylight</td>
                  </tr>
                  <tr class="border-top">
                    <td class="text-center border-bottom">mm</td>
                    <td class="text-left font font-weight-bold border-bottom">{{ ProductDetails.mouldOpeningStroke }}</td>
                    <td class="text-left border-right border-left border-bottom">Mould Opening Stroke</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>

</template>

<script>

import FooterMenu from "@/components/footer";
import NavBar from "@/components/navBar";


export default {
  name: "Product-details",
  components: {NavBar, FooterMenu},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-محصولات'
  },
  data: () => ({
    desserts: [
      {
        name: 'Frozen Yogurt',
        calories: 159,
      },
      {
        name: 'Ice cream sandwich',
        calories: 237,
      },
      {
        name: 'Eclair',
        calories: 262,
      },
      {
        name: 'Cupcake',
        calories: 305,
      },
      {
        name: 'Gingerbread',
        calories: 356,
      },
      {
        name: 'Jelly bean',
        calories: 375,
      },
      {
        name: 'Lollipop',
        calories: 392,
      },
      {
        name: 'Honeycomb',
        calories: 408,
      },
      {
        name: 'Donut',
        calories: 452,
      },
      {
        name: 'KitKat',
        calories: 518,
      },
    ],


    showLoaderDialog: false,
    isPageLoaded: false,
    ProductDetails: {},
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/ProductDetails?ID=" + this.$route.query.productId, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.ProductDetails = json.products
            console.log("json.products")
            console.log(json.products)
            this.isPageLoaded = true
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>


</style>
